import styled from 'styled-components';

const StyledIndustriesSpriteJpg = styled.div`
  position: relative;
  padding-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-right: 64px;
  padding-left: 64px;
  
  h4{
    text-align: center;
    margin: 0 auto;
    max-width: 66.66%;
  }
  
  .sprite-content--wrap{
    position: relative;
  }
  .boxes--wrap{
    position: relative;
    width: 100%;
    top: 160px;
    left: 0;
    z-index: 2;
    margin-bottom: ${props => props.theme.components_spacing_desk.xlarge}px;
    pointer-events: none;
  }
  .box--industries-wrap:nth-child(2){
    margin-left: 66.66% ;
  }
  .box--industries-wrap:nth-child(3){
    margin-left: 8.33%;
    margin-top: 80px;
  }
  .box--industries-wrap{
    position: relative;
    width: 33.33%;
    text-align: left;
  }
  .box--title{
    margin-bottom: 16px;
  }
  .box--text{
    color: ${props => props.theme.colors.grey_700};
  }
  .box--divisor::before{
    content: '';
    position: absolute;
    width: 7px;
    height: 7px;
    top: -3.5px;
    border-radius: 50%;
    background-color: #003D2B;
  }
  .box--divisor{
    position: relative;
    margin: 24px 0;
    border-bottom: 1px solid #BAB9B5;
  }
  
  
  canvas{
    position: absolute;
    width: 50%;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    max-width: 650px;
    z-index: 1;
    cursor: pointer;
  }
  .overlay--zoom{
    position: fixed;
    width: 100vw;
    height: 100vh;
    transform: translateX(-100%);
    top: 0; 
    left: 0;
    z-index: 10;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .overlay--zoom iframe {
    position: relative;
    top: 0;
    left; 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    border: none;
  }
  .overlay--zoom .close--overlay{
    position: absolute;
    right: 64px;
    top: 40px;
    z-index: 11;
    width: 44px;
    height: 44px;
    cursor: pointer;
  }

  .overlay--zoom .close--overlay img {
    display: block;
    width: 100%;
  }
  .mobile-tap{
    display: none;
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px
  }
 
  @media screen and (max-width: 1024px){
    .mobile-tap{
      position: relative;
      margin: 0 auto;
      display: block;
      text-align: center;
      padding: 0;
      transition: opacity .25s ease-out;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      width: 80px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 3;
      background-color: ${ props => props.theme.colors.green_secondary};
      flex: 0 0 80px;
    }
  }
  @media screen and (max-width: 1023px){
    padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    h4{
      max-width: 83.33%;
    }
    
    .sprite-content--wrap{
      display: flex;
      align-items: center;
      margin-top: 80px;
    }
    canvas{
      margin: 0 auto 80px !important;
    }
    canvas, .boxes--wrap{
      position: relative;
      flex: 0 0 50%;
      width: 50%;
      max-width: 50%;
      left: 0;
      transform: translate(0, 0);
    }
    .box--industries-wrap{
      width: 100%;
      margin: 0 auto 80px !important;
    }
    .boxes--wrap{
      margin-bottom: ${props => props.theme.components_spacing_tablet.xlarge}px;
    }
  }
  @media screen and (max-width: 767px){
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    h4{
      max-width: 83.33%;
    }
    .boxes--wrap{
      top: 0;
      margin-bottom: ${props => props.theme.components_spacing_mobile.xlarge}px;
    }
    .sprite-content--wrap{
      flex-direction: column;
    }
    canvas, .boxes--wrap{
      position: relative;
      width: 100%;
      max-width: 100%;
    }
    .box--industries-wrap{
      margin: 0 auto 40px !important;
    }
    .overlay--zoom .close--overlay{
      right: 24px;
    }
  }
`;

export {
  StyledIndustriesSpriteJpg,
};

